module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer":"Answer to {name}","new_comment":"New comment"},"fr":{"answer":"Répondre à {name}","new_comment":"Nouveau commentaire"}}')
  delete Component.options._Ctor
}
